import React from 'react';
import {Link} from 'react-router-dom';
import {Translate} from '../../config/TranslationProvider';
import {endOfToday, formatISO, startOfToday} from 'date-fns';
import {useCategories} from '../../api/hooks';
import Loader from '../pages/Loader';
import Error from '../pages/Error';
import config from '../../config/config';
import {generateRoute, useRoutes} from '../../routing/RouteProvider';
import {findCategory} from '../../helper';

const CategoryList = categories => {
    const routes = useRoutes();
    const filterPath = query => generateRoute(routes, 'events', {filter: query});

    const defaultFilter = {
        'end_date_from': formatISO(startOfToday()),
        'start_date_to': formatISO(endOfToday()),
    };

    const {data: allCategories, isLoading, error} = useCategories();

    if (isLoading) {
        return <Loader />;
    }

    if (error) {
        return <Error errors={[error]} />;
    }

    return (
        <>
            <div className="widget atbd_widget widget-card">
                <div className="atbd_widget_title">
                    <h2 className="h4"><span className="la la-bookmark" />&nbsp;<Translate value="categories" /></h2>
                </div>
                <div className="widget-body atbdp-widget-categories">
                    <ul className="atbdp_parent_category">
                        {categories.categories.map((value, key) => {
                            const filter = {...defaultFilter, 'categories': [value] };
                            return (
                                <li key={key}>
                                    <Link to={filterPath(filter)} aria-label={'filter-for-category-' + findCategory(allCategories, value).title}>
                                        <span className={config.categories[value]?.icon || 'icon'} />
                                        {findCategory(allCategories, value).title}
                                    </Link>
                                </li>
                            );
                        })}
                    </ul>
                </div>
            </div>
        </>
    );
};

export default CategoryList;
